export default __webpack_public_path__ + "static/media/25d01348-4f5c-4b4b-903a-843d8cdf8d1c.b67d9019.JPG";